import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface SecurityPageErrorsState {
    message: string;
}

const initialState: SecurityPageErrorsState = {
    message: '',
};

const securityPageErrors = createSlice({
    name: 'security/errors',
    initialState: initialState,
    reducers: {
        setSecurityPageError: (state, action: PayloadAction<string>) => {
            return { ...state, message: action.payload };
        },
        clearSecurityPageError: state => {
            return { ...state, message: '' };
        },
    },
});

export const { setSecurityPageError, clearSecurityPageError } =
    securityPageErrors.actions;
export const securityPageErrorsReducer = securityPageErrors.reducer;
export const selectSecurityPageError = (state: {
    securityPageErrors: SecurityPageErrorsState;
}) => state.securityPageErrors.message;
